// x .32, y .31
export function OpentronsAutoclavableDeckRiser(): JSX.Element {
  return (
    <svg id="DekRiser" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <g id="BgFill">
        <path
          id="BgFill-2"
          data-name="BgFill"
          fill="#e6e6e6"
          strokeWidth=".5px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 139.744 3.8533 c 0 -2.1142 -1.6896 -3.8533 -3.872 -3.8533 h -28.4768 c -0.4576 0 -0.8096 0.341 -0.8096 0.7843 v 2.7962 s 0 0 0 0 c 0 1.2958 -1.056 2.3188 -2.3936 2.3188 H 35.6928 c -1.3376 0 -2.3936 -1.023 -2.3936 -2.3188 h 0 V 0.7843 c 0 -0.4433 -0.352 -0.7843 -0.8096 -0.7843 H 4.0832 C 1.9008 0 0.1056 1.7391 0.1056 3.8533 H 0.1056 v 86.9891 H 0.1056 c 0 2.1142 1.7952 3.8533 3.9776 3.8533 h 28.4064 c 0.4576 0 0.8096 -0.341 0.8096 -0.7843 v -2.7962 c 0 -1.2958 1.056 -2.3188 2.3936 -2.3188 h 68.464 c 1.3376 0 2.3936 1.023 2.3936 2.3188 h 0 v 2.7962 c 0 0.4433 0.352 0.7843 0.8096 0.7843 h 28.4768 c 2.1824 0 3.872 -1.7391 3.872 -3.8533 V 3.8533 Z"
        />
      </g>
      <g id="Clips">
        <path
          id="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 14.2912 94.6957 h -0.0352 c -0.2816 0 -0.4928 -0.2046 -0.4928 -0.4774 h 0 s 0 0 0 0 v -3.1372 h 0 c 0 -1.1935 0.9856 -2.1483 2.2176 -2.1483 h 0.0704 c 1.232 0 2.2176 0.9548 2.2176 2.1483 h 0 v 3.1372 h 0 c 0 0.2728 -0.2112 0.4774 -0.4928 0.4774 h -0.0352"
        />
        <path
          id="Clip-2"
          data-name="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 122.0032 94.6957 h -0.0352 c -0.2816 0 -0.4928 -0.2046 -0.4928 -0.4774 h 0 s 0 0 0 0 v -3.1372 h 0 c 0 -1.1935 0.9856 -2.1483 2.2176 -2.1483 h 0.0704 c 1.232 0 2.2176 0.9548 2.2176 2.1483 h 0 v 3.1372 h 0 c 0 0.2728 -0.2112 0.4774 -0.4928 0.4774 h -0.0352"
        />
        <path
          id="Clip-3"
          data-name="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 14.2912 0 h -0.0352 c -0.2816 0 -0.4928 0.2046 -0.4928 0.4774 h 0 s 0 0 0 0 v 3.1372 h 0 c 0 1.1935 0.9856 2.1483 2.2176 2.1483 h 0.0704 c 1.232 0 2.2176 -0.9548 2.2176 -2.1483 h 0 V 0.4774 h 0 c 0 -0.2728 -0.2112 -0.4774 -0.4928 -0.4774 h -0.0352"
        />
        <path
          id="Clip-4"
          data-name="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 122.0032 0 h -0.0352 c -0.2816 0 -0.4928 0.2046 -0.4928 0.4774 h 0 s 0 0 0 0 v 3.1372 h 0 c 0 1.1935 0.9856 2.1483 2.2176 2.1483 h 0.0704 c 1.232 0 2.2176 -0.9548 2.2176 -2.1483 h 0 V 0.4774 h 0 c 0 -0.2728 -0.2112 -0.4774 -0.4928 -0.4774 h -0.0352"
        />
        <path
          id="Clip-5"
          data-name="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 0.1056 77.5775 h 0 c 0 -0.3069 0.2112 -0.5115 0.4928 -0.5115 h 0 h 0 h 3.2384 c 1.232 0 2.2176 0.9548 2.2176 2.1483 h 0 c 0 0 0 0.0682 0 0.0682 c 0 1.1935 -0.9856 2.1483 -2.2176 2.1483 H 0.5984 c -0.2816 0 -0.4928 -0.2046 -0.4928 -0.4774 H 0.1056"
        />
        <path
          id="Clip-6"
          data-name="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 139.7088 77.5775 h 0 c 0 -0.3069 -0.2112 -0.5115 -0.4928 -0.5115 h 0 h 0 h -1.408 s -1.8304 0 -1.8304 0 h 0 c -1.232 0 -2.2176 0.9548 -2.2176 2.1483 h 0 c 0 0 0 0.0682 0 0.0682 c 0 1.1935 0.9856 2.1483 2.2176 2.1483 h 1.8304 s 1.408 0 1.408 0 h 0 c 0.2816 0 0.4928 -0.2046 0.4928 -0.4774 h 0"
        />
        <path
          id="Clip-7"
          data-name="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 139.7088 13.8105 h 0 c 0 -0.3069 -0.2112 -0.5115 -0.4928 -0.5115 h 0 h 0 h -1.408 s -1.8304 0 -1.8304 0 h 0 c -1.232 0 -2.2176 0.9548 -2.2176 2.1483 h 0 c 0 0 0 0.0682 0 0.0682 c 0 1.1935 0.9856 2.1483 2.2176 2.1483 h 1.8304 s 1.408 0 1.408 0 h 0 c 0.2816 0 0.4928 -0.2046 0.4928 -0.4774 h 0"
        />
        <path
          id="Clip-8"
          data-name="Clip"
          fill="none"
          strokeWidth=".4px"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 0.1408 13.8105 h 0 c 0 -0.3069 0.2112 -0.5115 0.4928 -0.5115 h 0 h 0 h 3.2384 c 1.232 0 2.2176 0.9548 2.2176 2.1483 h 0 c 0 0 0 0.0682 0 0.0682 c 0 1.1935 -0.9856 2.1483 -2.2176 2.1483 H 0.6336 c -0.2816 0 -0.4928 -0.2046 -0.4928 -0.4774 H 0.1408"
        />
      </g>
    </svg>
  )
}
